import React from "react";
import { formatCompactCurrency, formatCurrency } from "../../utils/formatters";
import Sparkline from "../Sparkline";
import FavoriteButton from "../FavoriteButton";
import ChangeCell from "../ChangeCell";
import ActionButtons from "../ActionButtons";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./index.sass";

const MarketsTableRow = ({
  coin,
  isFavorite,
  onToggleFavorite,
  vsCurrency,
  futuresPairsSlugsSet,
}) => {
  const isSmallScreen = useMediaQuery("(max-width: 510px)");
  const isPositive = coin.price_change_percentage_24h >= 0;
  const volumeInCoin = coin.total_volume / coin.current_price;
  const sparklineData = coin.sparkline_in_7d?.price || [];
  const tradeQuoteCurrency = "USDT";

  const baseSymbol = coin.symbol.toUpperCase();
  const displayQuoteCurrency =
    baseSymbol === "USDT" ? "USD" : tradeQuoteCurrency;

  // Обрізаємо назву до 2 слів
  const shortName = coin.name.split(" ").slice(0, 2).join(" ");

  const getShortSymbol = (symbol) => {
    if (isSmallScreen && symbol.length > 3) {
      return `${symbol.slice(0, 3)}..`;
    }

    return symbol;
  };

  const shortSymbol = getShortSymbol(baseSymbol);
  const fullPair = `${baseSymbol}/${displayQuoteCurrency}`;
  const displayPair = `${shortSymbol}/${displayQuoteCurrency}`;
  const baseSymbolForLookup = String(coin.symbol || "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  const candidateSlug = `${baseSymbolForLookup}${tradeQuoteCurrency}`;
  const pairSlug =
    futuresPairsSlugsSet && futuresPairsSlugsSet.has(candidateSlug)
      ? candidateSlug
      : null;

  return (
    <tr className="markets-table-row">
      {/* PAIR COLUMN */}
      <td className="markets-table-row__cell markets-table-row__cell--pair">
        <div className="markets-table-row__cell-content markets-table-row__cell-content--meta">
          <FavoriteButton
            isFavorite={isFavorite}
            onToggle={() => onToggleFavorite(coin.id)}
          />
          <img
            src={coin.image}
            alt={coin.name}
            className="markets-table-row__image"
            width={32}
            height={32}
          />
          <div className="markets-table-row__meta-text">
            <p className="markets-table-row__pair" title={fullPair}>
              {displayPair}
            </p>
            <div className="markets-table-row__name-row">
              {/* Використовуємо обрізану назву */}
              <p className="markets-table-row__name markets-table-row__name--desktop">
                {shortName}
              </p>
              <p className="markets-table-row__name markets-table-row__name--mobile">
                {formatCompactCurrency(coin.total_volume, vsCurrency)}
              </p>
            </div>
          </div>
          <div className="markets-table-row__trade markets-table-row__trade--mobile">
            <ActionButtons pairSlug={pairSlug} />
          </div>
        </div>
      </td>

      {/* PRICE COLUMN */}
      <td className="markets-table-row__cell markets-table-row__cell--price">
        <div className="markets-table-row__cell-content markets-table-row__cell-content--price">
          <p className="markets-table-row__primary">
            {formatCurrency(coin.current_price, vsCurrency)}
          </p>
        </div>
      </td>

      {/* CHANGE COLUMN */}
      <td className="markets-table-row__cell markets-table-row__cell--change">
        <ChangeCell
          value={coin.price_change_percentage_24h}
          isPositive={isPositive}
        />
      </td>

      {/* MARKET CAP COLUMN */}
      <td className="markets-table-row__cell markets-table-row__cell--market-cap">
        <div className="markets-table-row__cell-content">
          <p className="markets-table-row__primary">
            {formatCompactCurrency(coin.market_cap, vsCurrency)}
          </p>
          <p className="markets-table-row__secondary markets-table-row__secondary--full">
            {formatCompactCurrency(coin.market_cap, vsCurrency)}
          </p>
        </div>
      </td>

      {/* VOLUME COLUMN */}
      <td className="markets-table-row__cell markets-table-row__cell--volume">
        <div className="markets-table-row__cell-content">
          <p className="markets-table-row__primary">
            {formatCompactCurrency(coin.total_volume, vsCurrency)}
          </p>
          <p className="markets-table-row__secondary">
            {`${Math.round(
              volumeInCoin,
            ).toLocaleString()} ${coin.symbol.toUpperCase()}`}
          </p>
        </div>
      </td>

      {/* CHART COLUMN */}
      <td className="markets-table-row__cell markets-table-row__cell--chart">
        <div className="markets-table-row__cell-content markets-table-row__cell-content--chart">
          <Sparkline
            data={sparklineData}
            color={isPositive ? "#2FA766" : "#E2464A"}
          />
        </div>
      </td>

      {/* ACTION COLUMN */}
      <td className="markets-table-row__cell markets-table-row__cell--action">
        <ActionButtons pairSlug={pairSlug} />
      </td>
    </tr>
  );
};

export default MarketsTableRow;
